// extracted by mini-css-extract-plugin
export default {"errors":"Cost_errors__7H7EO","warning":"Cost_warning__-LQcF"};